import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { misc } from "@/lib/misc";
import { HttpResponse, Interview, InterviewQueryParams } from "@/types";

export function useGetInterviews({
  jobId,
  queryOptions,
}: {
  jobId: string;
  queryOptions: InterviewQueryParams;
}) {
  const currentCompanyId = useCurrentCompanyId();

  const queryParams = misc.prepareQueryParams(queryOptions);
  const queryString = queryParams.toString();

  return useQuery({
    queryKey: ["interviews", currentCompanyId, jobId, queryString],
    queryFn: async () => {
      const basePath = `companies/${currentCompanyId}/jobs/${jobId}/interviews`;
      const path = queryString ? `${basePath}?${queryString}` : basePath;
      const res = await guacHttpClient.get<Interview[], HttpResponse<Interview[]>>(
        path
      );
      return res.data;
    },
    enabled: !!currentCompanyId && !!jobId,
  });
}
